export default __webpack_public_path__ + "static/media/Kannan.671031ef.png";